import { FC } from 'react'
import { Inspector } from '@sequencehq/core-components'
import { SparklesIcon } from '@heroicons/react/16/solid'
import { GreyGrey70 } from '@sequencehq/design-tokens'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ModelConfig } from 'ContractExtraction/components/ModelConfig'
import { Box } from '@chakra-ui/react'

export const ContractExtractionInspectorItem: FC = () => {
  const flags = useFlags()

  if (!flags.useContractIntakePrototype) {
    return null
  }

  return (
    <Inspector.IconItem
      data-testid="contract-extraction.inspector.item"
      tooltip="Contract Extraction"
      content={
        <Box width="320px" p={2}>
          <Inspector.Content title="Macro data refinement">
            <ModelConfig />
          </Inspector.Content>
        </Box>
      }
      icon={<SparklesIcon height="16px" width="16px" color={GreyGrey70} />}
    />
  )
}
